export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20flat%20lay%20composition%20with%20carefully%20arranged%20lifestyle%20and%20fashion%20elements%20including%20a%20woven%20straw%20hat%20a%20pair%20of%20minimalist%20sunglasses%20and%20a%20linen%20pouch%20bag%20on%20a%20textured%20cream%20surface%20bathed%20in%20soft%20golden%20hour%20sunlight%20creating%20gentle%20highlights%20and%20long%20shadows%20clean%20sophisticated%20composition%20with%20plenty%20of%20negative%20space%20no%20text%20no%20people%20elegant%20natural%20aesthetic&width=1800&height=800&seq=kakobuy-cta-v3-2026&orientation=landscape"
          alt="Shop with Kakobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 tracking-wide uppercase">
            Shop with Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-white/80 mb-10 max-w-xl mx-auto leading-relaxed">
            Access the most comprehensive Kakobuy Spreadsheet with verified products, trusted sellers, and direct shopping links. Start browsing now.
          </p>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-white rounded-full hover:bg-foreground-800 transition-all duration-200 cursor-pointer group"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 flex-shrink-0">
              <i className="ri-shopping-bag-line text-white text-sm"></i>
            </span>
            <span className="text-sm font-semibold uppercase tracking-wide whitespace-nowrap">
              Browse Kakobuy Spreadsheet
            </span>
            <i className="ri-arrow-right-up-line text-white/70 group-hover:text-white transition-colors ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}